<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0001 8.58586L17.9394 0.646522C18.1347 0.45126 18.4513 0.45126 18.6465 0.646522L19.3536 1.35363C19.5489 1.54889 19.5489 1.86547 19.3536 2.06074L11.4143 10.0001L19.3536 17.9394C19.5489 18.1347 19.5489 18.4513 19.3536 18.6465L18.6465 19.3536C18.4513 19.5489 18.1347 19.5489 17.9394 19.3536L10.0001 11.4143L2.06074 19.3536C1.86547 19.5489 1.54889 19.5489 1.35363 19.3536L0.646522 18.6465C0.45126 18.4513 0.451259 18.1347 0.646522 17.9394L8.58586 10.0001L0.646522 2.06074C0.45126 1.86547 0.45126 1.54889 0.646522 1.35363L1.35363 0.646522C1.54889 0.45126 1.86547 0.451259 2.06074 0.646522L10.0001 8.58586Z" fill="#152E39"/>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
